// Sdílený URL state pro agendy postavené na ListPage: aktivní pohled (záložka).
//
// Aktivní pohled žije v URL state paramu `view` (ne v serverové persistenci), aby platilo:
//   - reload / deeplink (view je v URL) → obnoví se uložený pohled,
//   - čerstvé otevření z menu/navigátoru (view v URL chybí) → první záložka („Vše").
// List-agenda ho zapojí přes `state: listPageViewState`; most `NavListPage` čte/zapisuje `view`.

import { param } from '../core/paramCodec';

/** State codec map list-agendy — aktivní pohled jako volitelný URL parametr. */
export const listPageViewState = {
  view: param.string().optional(),
};
